<template>
  <div>
    <import-page
      title="批量导入采购单"
      :loading="loading"
      :templateUrl="templateUrl"
      :columns="columns"
      :isValid="isValid"
      :limit="1000"
      :previewList="previewList"
      :importLoading="importLoading"
      @on-import="importList"
      @on-preview="previewFile"
    >
    </import-page>
  </div>
</template>

<script>
import ImportPage from "@/components/import-page";
import purchaseApi from "@/api/purchase";
import { CONST_IMPORT_PURCHASE_TEMPLATE_URL } from "@/config/constant";
export default {
  data() {
    return {
      columns: [
        {
          title: "入库类型",
          key: "inboundType",
          width: 200,
          align: "center",
        },
        {
          title: "来源单号",
          key: "originOrderNo",
          width: 200,
          align: "center",
        },
        {
          title: "仓库id",
          key: "warehouseId",
          width: 200,
          align: "center",
        },
        {
          title: "货主id",
          key: "customerId",
          width: 200,
          align: "center",
        },
        {
          title: "商品料号",
          key: "itemNo",
          width: 200,
          align: "center",
        },
        {
          title: "采购数量",
          key: "purchaseQuantity",
          width: 100,
          align: "center",
        },
        {
          title: "校验信息",
          key: "errorMsg",
          align: "center",
          fixed: "right",
          render: (h, params) => {
            const msg = params.row.errorMsg;
            return (
              <div>
                <el-tag type="success" v-show={!msg}>
                  校验成功
                </el-tag>
                <el-tooltip
                  class="item"
                  effect="dark"
                  content={msg}
                  placement="top"
                  v-show={msg}
                >
                  <el-tag type="danger">校验失败</el-tag>
                </el-tooltip>
              </div>
            );
          },
        },
      ],
      loading: false,
      templateUrl: CONST_IMPORT_PURCHASE_TEMPLATE_URL,
      isValid: false,
      previewList: [],
      importLoading: false,
    };
  },
  components: {
    ImportPage,
  },
  methods: {
    previewFile(fileUrl) {
      if (!fileUrl) {
        this.$message({
          message: "请先上传文件",
          type: "error",
        });
        return;
      }
      if (!/.(xls|xlsx)$/.test(fileUrl)) {
        this.$message({
          message: "您上传的文件格式不正确",
          type: "error",
        });
        return;
      }
      this.loading = true;
      purchaseApi
        .importPreview({
          fileUrl,
        })
        .then((res) => {
          this.previewList = res.value;
          const result = [];
          this.previewList.map((item) => {
            if (item.errorMsg) {
              result.push(item);
            }
          });

          this.isValid = result.length === 0;
          this.loading = false;
        });
    },
    importList() {
      this.importLoading = true;
      purchaseApi
        .batchImport({
          request: JSON.stringify(this.previewList),
        })
        .then((res) => {
          this.importLoading = false;
          if (res.value) {
            this.$message.success("导入成功");
            this.$router.back();
          } else {
            this.$message.error("导入失败");
          }
        })
        .finally(() => {
          this.importLoading = false;
        });
    },
  },
};
</script>
